var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"ifram",attrs:{"src":("https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=V4RBZ-ACNC3-5PS3C-3PJCV-MNMGH-OVF76&referer=myapp$coord=" + _vm.coord),"frameborder":"0","allow":"geolocation"}})])}
var staticRenderFns = []

export { render, staticRenderFns }